import { Component, OnInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { environment } from '../../../environments/environment';
import { FeedbackMessage } from './types';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'src/app/shareModule/services/shared.service';


@Component({
  selector: 'app-review-pending-complete-additional',
  templateUrl: './review-pending-complete-additional.component.html',
  styleUrls: ['./review-pending-complete-additional.component.scss'],
})
export class ReviewPendingCompleteAdditionalComponent implements OnInit {
  @ViewChild('toggleSliderRef') toggleSliderRef: ElementRef;

  send_Message: FormGroup;
  google_feedbacks: any;
  edit_google_review: any;
  edit_google_feedbacks: any;
  editFG: FormGroup;
  imageUploadForm: FormGroup;
  url_names: any;
  subAdmainName: any;
  saveSubadnminid: any;
  reviewData: string;
  submitted = false;
  imgUrl = environment.ImageUrl;
  img: File;
  get_all_feedback_URL: any;
  chaeckAdminStatus: any;
  sendsmsid: any;
  inboxID: number;
  review_link: any;
  feedbackDescription: any;
  imagepreview: any;
  subAdminData: any;
  productsShoutOut: Array<any> = [];
  flag: any;
  hideAdminData: any;
  admindatawithid: any = 0;
  reviewCountLimit: any = 100;
  googlecoundata: any;
  getallname: any;
  selectedName: any = '';
  feedbackMessages: Array<FeedbackMessage>;
  editGoogleNameFG: FormGroup;
  addEmailFG: FormGroup;
  updateEmailFG: FormGroup;
  updateProductFG: FormGroup;
  image_upload_link: any;
  user_id: number;
  edit_review_link: any;
  gfbid: any;
  is_approved: any;
  is_approved_message: any;
  feedbackmessagesObj: any;
  feedbackDataForSms: any;
  getallname_unsent: any;
  is_paid_message: string;
  is_paid: any;
  share_link: any;
  getLatestPhone: any;
  link_url: any = environment.baseUrl + `client-review-share`
  user_share_review_link: string;
  is_clicked_name: any = 0;
  show_review_link: any;
  show_client_desc: any;
  edit_client_desc: any;

  is_automation_checked = false;
  is_twice_automation_checked = false;
  is_bypass_slot_checked = false;
  edit_google_name_review: any;
  is_refresh_clicked = false;
  client_google_place_id: any = '';
  purchasedSlotCount: number = 0;

  name_color_checked = "0";
  google_name_link: any = "";
  isSliderOpen = false;
  sliderText: any = "";
  imageUrl = environment.ImageUrl;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {


      // this.spinner.show();
      this.checkUserType();
      // this.getadminlistdata();
      this.get_all_url_names();
      this.getAllname();
      this.get_admin_All_Req();
      // this.spinner.hide()

      if (this.admindatawithid != 0) {
        this.get_feedback_subadmin_google(this.admindatawithid);
      } else {
        this.get_feedback_subadmin_google(0);
      }


      this.send_Message = this.fb.group({
        phone: ["", [Validators.required]],
        name: ["", [Validators.required]],
        google_name: [""],
        amount: ["", [Validators.required]],
        nameId: ["", [Validators.required]],
      })

      this.imageUploadForm = this.fb.group({
        remark: [""],
        image_link: [""]
        // subadminid: ["", [Validators.required]],
      })

      this.editFG = new FormGroup({
        // feedbackNameurl: new FormControl(''),
        // feedbackName: new FormControl(''),
        description: new FormControl(''),
        client_remarks: new FormControl(''),
        user_remarks: new FormControl(''),
        points: new FormControl(0),
        unlimited_task: new FormControl(false),
        type: new FormControl('normal'),
        tags: new FormControl(''),
        limit_after_accept: new FormControl('24'),
        level_required: new FormControl('1'),
        // star: new FormControl(''),
      });

      this.editGoogleNameFG = this.fb.group({
        google_name: ['', [Validators.required]],
        google_name_link: ['']
      });

      this.addEmailFG = this.fb.group({
        userName: ['', [Validators.required]],
        email: ['', []],
        no_of_review: ['', []],
        google_place_id: ['', []]
      });

      this.updateEmailFG = this.fb.group({
        // name: ['', [Validators.required]],
        name_color: ['', [Validators.required]],
        is_automation: ['', [Validators.required]],
        is_twice_automation: ['', [Validators.required]],
        is_bypass_slot: ['', [Validators.required]],
        email: ['', [Validators.required]],
        client_desc: ['', [Validators.required]],
        google_place_id: ['', [Validators.required]],
        // no_of_review: ['', [Validators.required]]
        no_of_review: ['']
      });

      this.updateProductFG = this.fb.group({
        product_id: ['', [Validators.required]],
        product_slug: ['', [Validators.required]],
        no_of_review: ['', [Validators.required]],
      });

      // this.addEmailFG = new FormGroup({
      //   name: new FormControl(''),
      //   email: new FormControl(''),
      //   no_of_review: new FormControl('')
      // });
      // this.createReviewLoop(this.reviewCountLimit)
      // console.log(this.createReviewLoop(this.reviewCountLimit))
    }
  }

  onSelectName(value: any, name: any): void {
    this.getLatestPhone = value
    let nameData = this.getallname.filter(data => data.phno == value)
    nameData = nameData.length > 0 ? nameData[0] : {}
    // this.selectedName = value;
    this.send_Message.patchValue({
      phone: value,
      name: nameData.name,
      google_name: nameData.google_name,
      amount: nameData.amount,
      nameId: nameData.id,
    });
  }

  async refreshGoogleData() {
    try {
      this.spinner.show();
      if (this.admindatawithid) {
        if (this.client_google_place_id != "") {
          this.spinner.show();
          let feedbackArray = this.google_feedbacks;
          // let responseData = await this.auth.refreshGoogleData(this.client_google_place_id);
          const update_1_ids = []
          this.auth.refreshGoogleData(this.client_google_place_id).subscribe(
            (response: any) => {
              this.is_refresh_clicked = true
              let googleApiReviewData = response.body.length > 0 ? response.body[0].reviews_data : []
              // let googleApiReviewData = response.body.result.reviews
              for (let i in feedbackArray) {
                if (feedbackArray[i].feedbackmessages.length > 0 && feedbackArray[i].feedbackmessages[0].google_name != '') {

                  let googleNameArray = feedbackArray[i].feedbackmessages[0].google_name.split(',');
                  googleNameArray = googleNameArray.map((value) => value.trim());
                  feedbackArray[i].is_feedback_available = 0;
                  feedbackArray[i].is_google_review = 0;
                  for (let j in googleApiReviewData) {
                    // if(googleNameArray.includes(googleApiReviewData[j].author_name)){
                    if (googleNameArray.includes(googleApiReviewData[j].author_title)) {
                      feedbackArray[i].is_feedback_available = 1;
                      feedbackArray[i].is_google_review = 1;
                      update_1_ids.push(feedbackArray[i].id)
                    }
                    /* else {
                      console.log('------------------else-----------------------------------');
                      feedbackArray[i].is_feedback_available = 0
                    } */
                  }

                }
              }

              this.google_feedbacks = feedbackArray;

              const formData = {
                client_id: this.admindatawithid,
                update_1_id: JSON.stringify(update_1_ids)
              }

              this.auth.update_google_review_from_google(formData).subscribe(
                (response: any) => {
                  this.spinner.hide();
                }
              )

            },
            (error) => {
              if (error.status == 401) {
                this.local.logout();
                this.router.navigate(['/admin']);
              }
            }
          );
          // this.spinner.hide();

        } else {
          this.toastr.error('Please add place id for this client');
        }
      } else {
        this.spinner.hide();
        this.toastr.error('Please Select client first');
      }
      // this.spinner.hide();
    } catch (err) {
      this.spinner.hide();
    }
  }

  createReviewLoop(number: number) {
    // return new Array(number);
    // return new Array(number).fill(0)
    //   .map((n, index) => index + 1);
    const numArray = [5, 10, 15, 20, 30, 50, 100]
    /*  for(let i = 1; i <= number; i++){
       if(i % 5 == 0){
         numArray.push(i)
       }
     }
     console.log(numArray,'--numArray--'); */

    return numArray
  }

  checkUserType() {
    let x = localStorage.getItem("user");
    let admintype = JSON.parse(x);
    this.chaeckAdminStatus = admintype.userType;
  }


  get send_Message_v() { return this.send_Message.controls }
  get imageUploadForm_v() { return this.imageUploadForm.controls }
  get editGoogleNameFG_v() { return this.editGoogleNameFG.controls }
  get addEmailFG_v() { return this.addEmailFG.controls }
  get updateEmailFG_v() { return this.updateEmailFG.controls }
  get updateProductFG_v() { return this.updateProductFG.controls }

  sendMessage() {
    this.submitted = true;
    if (this.send_Message.invalid) {
      return false;
    }
    let sendata = {
      ...this.send_Message.value,
      gfbid: this.sendsmsid,
    };
    if (this.feedbackDescription.trim() == '') {
      return this.toastr.error('Please add review.');
    }
    if (this.review_link.trim() == '') {
      return this.toastr.error('Please add review link.');
    }

    // if (this.purchasedSlotCount <= 0) {
    //   return this.toastr.error("Client has not purchased slots.");
    // }
    // this.image_upload_link = `https://myvip.asia/#/review-image-upload/${btoa(this.sendsmsid)}/${btoa(this.getLatestPhone)}`;
    this.image_upload_link = `https://myvip.asia/#/review-image-upload?id=${btoa(this.sendsmsid)}&phone=${btoa(this.getLatestPhone)}&manual_type=${btoa('1')}`;
    this.user_share_review_link = `https://myvip.asia/#/user-review-share?u=${btoa(this.getLatestPhone)}`;
    if (this.image_upload_link.trim() == '') {
      return this.toastr.error('Please add image upload link.');
    }


    this.auth.sendSmsFeedback_additional(sendata, this.feedbackDescription, this.review_link, this.image_upload_link, this.user_share_review_link).subscribe(
      (response: any) => {
        this.get_feedback_subadmin_google(this.admindatawithid);
        this.toastr.success('Message sent successfully');
        this.modalService.dismissAll();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else if (error.status == 400) {
          this.toastr.error(error.error.message)
        }
      }
    );
  }

  feedbackIsProduct = false;
  get_feedback_subadmin_google(data) {
    let params = {
      id: data,
      is_product: this.feedbackIsProduct,
    }
    this.auth.get_feedback_subadmin_google(params).subscribe(
      (response: any) => {
        this.google_feedbacks = response.body;
        this.googlecoundata = this.google_feedbacks.length
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  get_admin_All_Req() {
    this.spinner.show();
    this.auth.get_other_admin_All_Req().subscribe(
      (response: any) => {
        // this.google_feedbacks = response.body;
        this.sliderText = response.body.sliderText;
        this.subAdminData = []
        this.hideAdminData = []
        this.url_names = response.body.c;
        // const adminNameArray = response.body.b.getnameByAdmin
        this.getallname = response.body.b.getnameByAdmin;
        this.productsShoutOut = response.body.products;
        response.body.a.map((e) => {
          if (e.hideUser == 0) {
            e.link = `${this.link_url}?c=${btoa(e.id)}`
            // e.link = `${this.link_url}?c=${btoa(e.id)}`
            this.subAdminData.push(e)
          } else {
            e.link = `${this.link_url}?c=${btoa(e.id)}`
            // e.link = `${this.link_url}?c=${btoa(e.id)}`
            this.hideAdminData.push(e)
          }
          let googleReviewCount = e.feedback_googles.length;
          let googleReviewArray = e.feedback_googles;
          let reviewDescriptionCount = 0;
          let noReviewDescriptionCount = 0;
          for (let i in googleReviewArray) {
            if (googleReviewArray[i].description != '' && googleReviewArray[i].smscount == 0) {
              reviewDescriptionCount += 1
              noReviewDescriptionCount += 1
            }
          }
          e.reviewDescriptionCount = reviewDescriptionCount;
          e.noReviewDescriptionCount = noReviewDescriptionCount;
          e.isAllDescriptionEmpty = (reviewDescriptionCount == googleReviewCount) ? true : false
          /* for(let i in googleReviewArray){
            if(googleReviewArray[i].description == ''){
              reviewDescriptionCount += 1
            }
          }
          e.isAllDescriptionEmpty = (reviewDescriptionCount == googleReviewCount) ? true : false */
        })
        this.spinner.hide();

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  getadminlistdata() {
    this.auth.get_other_admin_All_Data().subscribe(
      (response: any) => {
        // this.google_feedbacks = response.body;
        this.subAdminData = []
        this.hideAdminData = []
        response.body.map((e) => {
          if (e.hideUser == 0) {
            e.link = `${this.link_url}?c=${btoa(e.id)}`
            // e.link = `${this.link_url}?c=${btoa(e.id)}`
            this.subAdminData.push(e)
          } else {
            e.link = `${this.link_url}?c=${btoa(e.id)}`
            // e.link = `${this.link_url}?c=${btoa(e.id)}`
            this.hideAdminData.push(e)
          }

        })
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  getDataByUser(id, reviewData) {
    // return // add to stop
    this.flag = id;
    this.admindatawithid = id;
    this.client_google_place_id = reviewData.google_place_id;
    const reviewCount = reviewData.feedback_googles.length;
    this.show_review_link = reviewData.feedback_googles.length > 0 ? reviewData.feedback_googles[reviewCount - 1].review_link : "";
    this.show_client_desc = reviewData.feedback_googles.length > 0 ? reviewData.feedback_googles[reviewCount - 1].client_desc : "";
    this.share_link = reviewData ? reviewData.link : "";
    this.is_clicked_name = 1;
    this.feedbackIsProduct = false;
    this.get_feedback_subadmin_google(this.admindatawithid)
    this.get_specific_feedback_manager_url(this.admindatawithid);
  }
  editReview(content: string, id: number, feedback) {

    this.edit_google_review = id;
    this.auth.edit_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.edit_google_feedbacks = response.body.edit_feedback_subadmin_google;
        this.modalService.open(content, {
          backdropClass: 'light-blue-backdrop',
          size: 'md',
        });


        this.editFG.patchValue({
          feedbackNameurl: this.edit_google_feedbacks.feedbackNameurl == null ? this.url_names.findFeedbackNames[0]?.url_name : this.edit_google_feedbacks.feedbackNameurl,
          feedbackName: this.edit_google_feedbacks.feedbackName,
          description: this.edit_google_feedbacks.description != null ? this.edit_google_feedbacks.description : "",
          client_remarks: this.edit_google_feedbacks.client_remarks != null ? this.edit_google_feedbacks.client_remarks : "",
          user_remarks: this.edit_google_feedbacks.user_remarks != null ? this.edit_google_feedbacks.user_remarks : "",
          star: this.edit_google_feedbacks.star == 0 ? 5 : this.edit_google_feedbacks.star,
          points: this.edit_google_feedbacks.points != null ? this.edit_google_feedbacks.points : 0,
          unlimited_task: this.edit_google_feedbacks.unlimited_task == 1 ? true : false,
          type: this.edit_google_feedbacks.type != null ? this.edit_google_feedbacks.type : "normal",
          tags: this.edit_google_feedbacks.tags != null ? this.edit_google_feedbacks.tags : "",
          limit_after_accept: this.edit_google_feedbacks.limit_after_accept != null ? this.edit_google_feedbacks.limit_after_accept : "24",
          level_required: this.edit_google_feedbacks.level_required != null ? this.edit_google_feedbacks.level_required : "1",
        });
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  editGoogleName(content: string, id: number, feedback, feedbackMessage) {

    this.edit_google_name_review = feedbackMessage.id;
    this.auth.get_google_name_link(feedbackMessage.id).subscribe(
      (response: any) => {

        this.modalService.open(content, {
          backdropClass: 'light-blue-backdrop',
          size: 'md',
          // backdrop: 'static',
        });

        this.editGoogleNameFG.patchValue({
          google_name: feedbackMessage.google_name,
          google_name_link: response.body.google_name_link
        });
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  update_google_name() {
    this.submitted = true;
    if (this.editGoogleNameFG.invalid) {
      return false;
    }

    this.auth
      .update_google_name(this.editGoogleNameFG.value, this.edit_google_name_review)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  addUserEmail(content: string, id: number, type: any, reviewData: any) {
    if (type == 2) {
      this.user_id = id
      const reviewCount = reviewData.feedback_googles.length
      this.edit_review_link = reviewData.feedback_googles.length > 0 ? reviewData.feedback_googles[reviewCount - 1].review_link : ""
      this.edit_client_desc = reviewData.feedback_googles.length > 0 ? reviewData.feedback_googles[reviewCount - 1].client_desc : ""
      this.updateEmailFG.patchValue({
        email: this.edit_review_link,
        client_desc: this.edit_client_desc,
        google_place_id: reviewData.google_place_id
      });
      this.is_automation_checked = reviewData.is_automation == 1 ? true : false;
      this.is_twice_automation_checked = reviewData.is_twice_automation == 1 ? true : false;
      this.share_link = reviewData ? reviewData.link : "";
      this.is_bypass_slot_checked = reviewData.is_bypass_slot == 1 ? true : false;
      this.name_color_checked = reviewData.nameColor.toString();
    }
    this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      size: 'md',
      // backdrop: 'static',
    });

  }
  createUserEmail() {
    this.auth
      .add_review_user(this.addEmailFG.value)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );

    /* return
    this.edit_google_review = id;
    this.auth.edit_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.edit_google_feedbacks = response.body.edit_feedback_subadmin_google;
        this.reviewData = response.body.data
        this.modalService.open(content, {
          backdropClass: 'light-blue-backdrop',
          size: 'md',
          backdrop: 'static',
        });

        let data = this.edit_google_feedbacks.feedbackNameurl == null ? this.url_names.findFeedbackNames[0]?.url_name : this.edit_google_feedbacks.feedbackNameurl

        this.onChange(data)


        this.editFG.patchValue({
          feedbackNameurl: this.edit_google_feedbacks.feedbackNameurl == null ? this.url_names.findFeedbackNames[0]?.url_name : this.edit_google_feedbacks.feedbackNameurl,
          feedbackName: this.edit_google_feedbacks.feedbackName,
          description: this.edit_google_feedbacks.description != null ? this.edit_google_feedbacks.description : "",
          star: this.edit_google_feedbacks.star == 0 ? 5 : this.edit_google_feedbacks.star,
        });
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/']);
        }
      }
    ); */
  }
  get_all_url_names() {
    this.auth.get_feedback_manager_url().subscribe(
      (response: any) => {
        this.url_names = response.body;

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  get_specific_feedback_manager_url(id) {
    this.auth.get_specific_feedback_manager_url(id).subscribe(
      (response: any) => {
        this.url_names = response.body.c;

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  onChange(event) {
    let formData = new FormData();
    formData.append('current_module', event);
    this.auth.get_all_feedback_module(formData).subscribe((response: any) => {
      (response)
      this.get_all_feedback_URL = response.body.filter(x => x.description.trim().length != 0)

    });
  }

  subonChange(data) {
    this.editFG.patchValue({
      description: data
    })
  }

  add_user_email_data() {
    this.submitted = true;
    if (this.addEmailFG.invalid) {
      return false;
    }
    // return
    this.auth
      .add_review_user(this.addEmailFG.value)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  update_user_email_data() {
    this.submitted = true;
    if (this.updateEmailFG.invalid) {
      return false;
    }
    // return
    /* const reqObj = {
      ...this.addEmailFG.value
    } */
    this.updateEmailFG.value.user_id = this.user_id
    this.show_client_desc = this.updateEmailFG.value?.client_desc;
    this.auth
      .edit_review_user(this.updateEmailFG.value)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          // this.getDataByUser(this.user_id, response.body)

          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  editProductData(content: string, product: any) {
    console.log(product, 'product');

    this.updateProductFG.patchValue({
      product_id: product.id,
      product_slug: product.slug,
    });
    this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      size: 'md',
    });
  }

  update_product_data() {
    this.submitted = true;
    if (this.updateProductFG.invalid) {
      return false;
    }

    this.assignProductReview({
      id: parseInt(this.updateProductFG.value.product_id),
      slug: this.updateProductFG.value.product_slug,
      no_of_review: parseInt(this.updateProductFG.value.no_of_review),
    })
  }

  update_edit_google_feedbacks() {
    const checkNewLine = this.editFG.value.description;
    if (checkNewLine.includes("\n")) {
      return this.toastr.error("Please do not leave gaps before and after text");
    }
    this.auth
      .update_edit_google_feedbacks(this.editFG.value, this.edit_google_review)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  update_circle(id) {
    this.auth
      .update_circle({ is_circle: 1 }, id)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }
  verify_review(id: number) {
    this.auth.verify_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.ngOnInit();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  formateDate(date: number) {
    return moment(date * 1000).format("DD/MM/YYYY hh:mm a");
  }

  sendsms(phone: number, id, description, review_link, feedbackData) {
    this.sendsmsid = id;
    this.review_link = review_link;
    this.feedbackDataForSms = feedbackData;
    this.feedbackDescription = description;
    const sentfeedbackmessages = feedbackData.feedbackmessages

    this.auth.purchasedSlots({ client_id: this.admindatawithid }).subscribe(
      (response: any) => {
        this.purchasedSlotCount = response.body.count;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );

    this.auth.getSmsFeedback(id).subscribe(messages => {
      this.feedbackMessages = messages.body;
      this.getAllNameOther(feedbackData.ratingByUserId)
      /* let phoneArray = []
      for(let i in sentfeedbackmessages){
        if(sentfeedbackmessages[i].is_approved == 1){
          phoneArray.push(sentfeedbackmessages[i].phone)
        }
      }
      console.log(phoneArray,'----phoneArray---');
      
      phoneArray = [...new Set(phoneArray)]
      console.log(phoneArray,'----phoneArray---2222222222');
      this.getallname_unsent = this.getallname.filter(data => !phoneArray.includes(data.phno) ) */
      debugger;
      this.modalService.open(phone, {
        backdropClass: 'light-blue-backdrop',
        size: 'md',
        // backdrop: 'static',
      });
      this.inboxID = id;
    })


  }

  imageUpload(content: string, id: number) {
    this.getimagdata(id)
    this.SubAdminNameSelect();
    this.getAllname();
    this.saveSubadnminid = id
    this.modalService.open(content, { size: 'md' });
    // this.verify_review(id)
  }


  viewlimage(content: string, id) {
    this.getimagdata(id)
    this.saveSubadnminid = id
    this.modalService.open(content, { size: 'md' });
    // this.verify_review(id)


  }

  getimagdata(id) {
    this.auth.get_feedbackimagedata(id).subscribe(
      (response: any) => {
        this.imagepreview = response.body.image
        this.imageUploadForm.patchValue({
          image_link: response.body.image_link
        });
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }


  SubAdminNameSelect() {
    let formData = new FormData();
    formData.append('subAdminName', 'subAdmin');
    this.auth.get_subAdminName(formData).subscribe(
      (response: any) => {
        this.subAdmainName = response.body;

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  onFileChanged(event) {
    this.img = event.target.files[0];
  }

  verify_review_token() {


    this.submitted = true;
    if (this.imageUploadForm.invalid) {
      return false;
    }
    const { subadminid, remark, image_link } = this.imageUploadForm.value

    const formData = new FormData()
    formData.append("image", this.img)
    // formData.append("subadminid", subadminid)
    formData.append("remark", "")
    formData.append("image_link", image_link)
    formData.append("saveSubadnminid", this.saveSubadnminid)
    this.auth.reviewImageUploadForm(formData).subscribe(
      (response: any) => {
        // this.subAdmainName = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );

    this.verify_review(this.saveSubadnminid)
    this.modalService.dismissAll();
  }

  unhide(even, status) {
    // return // add to stop
    this.hideuserfunction(parseInt(even), status)
  }
  hideURL(id, status) {
    // return // add to stop
    this.hideuserfunction(id, status)
  }

  hideuserfunction(id, status) {
    // hideUser
    this.auth.hideGoogelreview(id, status).subscribe(
      (response: any) => {
        this.getadminlistdata()
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  saveFeedbackApproval(content, gfbid, is_approved, feedbackmessagesObj, type) {
    this.gfbid = gfbid
    this.is_approved = is_approved
    this.feedbackmessagesObj = feedbackmessagesObj

    this.is_approved_message = is_approved == 1 ? 'Approve?' : 'Dis-approve?'
    if (type == 1) {
      this.modalService.open(content, { size: 'md' });
    } else {
      let nameData = this.getallname.filter(data => data.phno == feedbackmessagesObj.phone && data.name == feedbackmessagesObj.name)
      nameData = nameData.length > 0 ? nameData[0] : {}
      // return
      const saveObj = {
        gfbid,
        is_approved,
        feedback_msg_id: feedbackmessagesObj.id
      }
      // update approval
      this.auth.saveFeedbackApproval(saveObj).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    }

  }

  saveFeedbackPayment(content, gfbid, is_paid, feedbackmessagesObj, type) {
    this.gfbid = gfbid
    this.is_paid = is_paid
    this.feedbackmessagesObj = feedbackmessagesObj

    this.is_paid_message = is_paid == 1 ? 'Approve?' : 'Dis-approve?'
    if (type == 1) {
      this.modalService.open(content, { size: 'md' });
    } else {
      let nameData = this.getallname.filter(data => data.phno == feedbackmessagesObj.phone && data.name == feedbackmessagesObj.name)
      nameData = nameData.length > 0 ? nameData[0] : {}
      // return
      const saveObj = {
        gfbid,
        is_paid,
        feedback_msg_id: feedbackmessagesObj.id
      }
      // update approval
      this.auth.saveFeedbackPayment(saveObj).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    }

  }

  getAllname() {
    this.auth.getnameByAdmin().subscribe(
      (response: any) => {
        this.getallname = response.body.getnameByAdmin
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  getAllNameOther(sub_admin_id) {
    this.auth.getnameByAdminOther(sub_admin_id).subscribe(
      (response: any) => {
        // this.getallname = response.body.getnameByAdmin
        this.getallname_unsent = response.body.getnameByAdmin
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  copyToClipboardMessage() {
    this.toastr.success('Copied');
  }

  writeReview(event) {
    if (event.keyCode == 13 || event.keyCode == 16) {
      event.preventDefault();
    }
  }

  toggleSlider() {
    // this.isSliderOpen = !this.isSliderOpen;
    this.addClassToElement('active');
  }

  addClassToElement(className: string) {
    this.renderer.addClass(this.toggleSliderRef.nativeElement, className);
  }

  sliderLeave(className: string) {
    this.renderer.removeClass(this.toggleSliderRef.nativeElement, className);
  }

  updateSliderText(event) {
    let formData = new FormData();
    formData.append("sliderText", event.target.value);
    this.auth.updateSliderText(formData).subscribe(
      (response: any) => {
        console.log(response)
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }
  page = 1;
  limit = 10;
  totalItems = 0;
  totalPages = 0;
  products: any = [];

  initializeProducts(search = '') {
    const payload = {
      page: this.page,
      limit: this.limit,
      search: search
    };

    this.auth.getShoutOutProducts(payload).subscribe(
      (response: any) => {
        console.log(response);
        const result = response.body;
        if (result && result.products) {
          this.products = result.products;
          this.totalItems = result.pagination.totalRecords || 0;
          this.totalPages = Math.ceil(this.totalItems / this.limit);
        }
      },
    );
  }

  onPageChange(page: number) {
    this.page = page;
    this.initializeProducts();
  }

  onSearchProduct(event: any) {
    this.page = 1;
    this.initializeProducts(event.target.value);
  }

  addProduct(modal: any) {
    this.initializeProducts();
    this.modalService.open(modal, { size: 'md' });
  }

  assignProductReview(product: any) {
    this.auth.assignProductReview({
      product_id: product.id,
      product_slug: product.slug,
      no_of_review: product.no_of_review || 1,
    }).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.get_admin_All_Req()
        this.modalService.dismissAll();
      },
      (error) => {
        this.toastr.error(error.error.message);
      }
    );
  }

  getFeedbackByProduct(product: any) {
    this.flag = product.id;
    this.admindatawithid = product.id;
    this.feedbackIsProduct = true;
    this.get_feedback_subadmin_google(this.admindatawithid);
    this.get_specific_feedback_manager_url(this.admindatawithid);
  }
}
